import React from "react";

import dragonIcon from "src/assets/icons/maneno/dragon.svg";
import growthIcon from "src/assets/icons/maneno/growth.svg";
import bookIcon from "src/assets/icons/maneno/book.svg";
import bellIcon from "src/assets/icons/maneno/bell.svg";
import profileIcon from "src/assets/icons/maneno/profile.svg";

export const IconDashboard = () => <img src={dragonIcon} alt="" aria-hidden="true" width="24" height="24" />;

export const IconProgress = () => <img src={growthIcon} alt="" aria-hidden="true" width="24" height="24" />;

export const IconLibrary = () => <img src={bookIcon} alt="" aria-hidden="true" width="24" height="24" />;

export const IconNotification = () => <img src={bellIcon} alt="" aria-hidden="true" width="24" height="24" />;

export const IconProfile = () => <img src={profileIcon} alt="" aria-hidden="true" width="24" height="24" />;

export const IconTeacherResources = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3L2 8l10 5 10-5-10-5z" fill="currentColor" opacity={0.15} />
    <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconAssignments = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="5" y="3" width="14" height="18" rx="2" fill="currentColor" opacity={0.15} />
    <rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 7h6M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const IconReports = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 7a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V7z" fill="currentColor" opacity={0.15} />
    <path
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const IconSchools = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3 10l9-7 9 7v11H3V10z" fill="currentColor" opacity={0.15} />
    <path
      d="M3 21h18M6 21V10M18 21V10M3 10l9-7 9 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="10" y="15" width="4" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const IconSignOut = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 17l5-5-5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 12H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
